export var FilmCategory;
(function(FilmCategory) {
    FilmCategory[/**
     * Indicates that the [[Film]] is currently screening.
     *
     * @remarks
     * A film is considered 'now showing' if its next scheduled [[Showtime]] is within the configured 'now showing' window.
     *
     * A film with this category will not belong to any other categories.
     */ "NowShowing"] = "NowShowing";
    FilmCategory[/**
     * Indicates that the [[Film]] is screening in the future.
     *
     * @remarks
     * A film is considered 'coming soon' if its next scheduled [[Showtime]] is after the 'now showing' window,
     * or if it has no scheduled [[Showtime]] entities and is manually configured to appear as 'coming soon'.
     *
     * A film with this category may also belong to [[AdvanceBooking]], but not [[NowShowing]].
     */ "ComingSoon"] = "ComingSoon";
    FilmCategory[/**
     * Indicates that the [[Film]] is currently available for advance bookings.
     *
     * @remarks
     * A [[Film]] is available for advance bookings if it belongs to [[ComingSoon]],
     * has an active [[FilmAdvanceBookingPeriod]], and has some [[Showtime]] entities scheduled.
     *
     * This category is a subset of [[ComingSoon]], meaning that a [[Film]] with this
     * category will always also belong to [[ComingSoon]].
     *
     * A [[Film]] belonging to this category may not be available for advance bookings by all patrons,
     * due to an unmet [[FilmAdvanceBookingPeriod.restriction]].
     */ "AdvanceBooking"] = "AdvanceBooking";
})(FilmCategory || (FilmCategory = {}));

//# sourceMappingURL=film-category.js.map